import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';

function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      {/* 히어로 섹션 */}
      <section className="relative py-24 sm:py-32">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1528127269322-539801943592?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" 
            alt="베트남 하롱베이 풍경" 
            className="w-full h-full object-cover brightness-50"
          />
        </div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              행복한 국제 결혼의 시작,<br />
              베트남에서 새로운 인연을 만나세요
            </h1>
            <p className="text-xl text-white opacity-90 mb-8">
              10년 이상의 경험을 바탕으로 믿을 수 있는 매칭 서비스를 제공합니다.
              진심 어린 커플링과 철저한 검증 시스템으로 여러분의 행복한 미래를 지원합니다.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Link 
                to="/match" 
                className="bg-white text-primary-700 hover:bg-gray-100 px-8 py-3 rounded-md text-lg font-medium inline-block text-center"
              >
                매칭 서비스 알아보기
              </Link>
              <Link 
                to="#" 
                className="bg-transparent border border-white text-white hover:bg-white/10 px-8 py-3 rounded-md text-lg font-medium inline-block text-center"
              >
                상담 신청하기
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* 서비스 소개 섹션 */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              신뢰할 수 있는 국제 결혼 서비스
            </h2>
            <p className="text-xl text-gray-600">
              저희는 정직하고 투명한 방식으로 국제 결혼을 원하는 분들에게 맞춤형 서비스를 제공합니다.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
              <div className="text-primary-600 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">철저한 신원 확인</h3>
              <p className="text-gray-600">
                모든 회원은 엄격한 신원 확인 과정을 거치며, 신뢰할 수 있는 정보만을 제공합니다.
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
              <div className="text-primary-600 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">맞춤형 매칭 서비스</h3>
              <p className="text-gray-600">
                성향과 희망 조건을 고려한 맞춤형 매칭으로 진정한 인연을 찾을 수 있도록 도와드립니다.
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
              <div className="text-primary-600 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">전문 상담 지원</h3>
              <p className="text-gray-600">
                경험 많은 전문 상담사가 결혼 준비부터 입국, 정착까지 전 과정을 도와드립니다.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* 프로세스 섹션 */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              국제 결혼의 모든 과정을 함께합니다
            </h2>
            <p className="text-xl text-gray-600">
              처음부터 끝까지 전문가와 함께하는 안심 프로세스
            </p>
          </div>
          
          <div className="relative">
            {/* 프로세스 라인 */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-primary-200"></div>
            
            <div className="space-y-12 md:space-y-0 relative">
              {/* 프로세스 단계 1 */}
              <div className="md:flex items-center md:space-x-6 mb-12">
                <div className="md:w-1/2 md:text-right md:pr-8 mb-4 md:mb-0">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">1. 상담 및 신청</h3>
                  <p className="text-gray-600">
                    전문 상담사와의 1:1 맞춤 상담을 통해 원하는 조건과 희망사항을 상세히 파악합니다.
                  </p>
                </div>
                <div className="md:w-10 flex justify-center relative">
                  <div className="w-10 h-10 rounded-full bg-primary-600 text-white flex items-center justify-center relative z-10">
                    1
                  </div>
                </div>
                <div className="md:w-1/2 md:pl-8 hidden md:block">
                  {/* 오른쪽 빈 공간 */}
                </div>
              </div>
              
              {/* 프로세스 단계 2 */}
              <div className="md:flex items-center md:space-x-6 mb-12">
                <div className="md:w-1/2 md:pr-8 hidden md:block">
                  {/* 왼쪽 빈 공간 */}
                </div>
                <div className="md:w-10 flex justify-center relative">
                  <div className="w-10 h-10 rounded-full bg-primary-600 text-white flex items-center justify-center relative z-10">
                    2
                  </div>
                </div>
                <div className="md:w-1/2 md:text-left md:pl-8 mb-4 md:mb-0">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">2. 맞춤 프로필 제안</h3>
                  <p className="text-gray-600">
                    고객님의 희망 조건에 맞는 검증된 베트남 여성의 프로필을 제안해 드립니다.
                  </p>
                </div>
              </div>
              
              {/* 프로세스 단계 3 */}
              <div className="md:flex items-center md:space-x-6 mb-12">
                <div className="md:w-1/2 md:text-right md:pr-8 mb-4 md:mb-0">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">3. 화상 만남 및 현지 방문</h3>
                  <p className="text-gray-600">
                    화상 통화로 첫 인사를 나누고, 마음이 맞으면 현지 방문을 통해 직접 만남을 가집니다.
                  </p>
                </div>
                <div className="md:w-10 flex justify-center relative">
                  <div className="w-10 h-10 rounded-full bg-primary-600 text-white flex items-center justify-center relative z-10">
                    3
                  </div>
                </div>
                <div className="md:w-1/2 md:pl-8 hidden md:block">
                  {/* 오른쪽 빈 공간 */}
                </div>
              </div>
              
              {/* 프로세스 단계 4 */}
              <div className="md:flex items-center md:space-x-6">
                <div className="md:w-1/2 md:pr-8 hidden md:block">
                  {/* 왼쪽 빈 공간 */}
                </div>
                <div className="md:w-10 flex justify-center relative">
                  <div className="w-10 h-10 rounded-full bg-primary-600 text-white flex items-center justify-center relative z-10">
                    4
                  </div>
                </div>
                <div className="md:w-1/2 md:text-left md:pl-8">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">4. 결혼 및 비자 지원</h3>
                  <p className="text-gray-600">
                    결혼이 결정되면 현지 결혼식부터 한국 입국, 비자 발급까지 모든 절차를 도와드립니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* 성공 사례 섹션 */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              행복한 커플들의 이야기
            </h2>
            <p className="text-xl text-gray-600">
              저희 서비스를 통해 행복한 가정을 이룬 커플들의 진솔한 후기입니다.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
              <div className="flex items-center mb-6">
                <div className="mr-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img 
                      src="https://images.unsplash.com/photo-1559624989-7b9303bd9792?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" 
                      alt="김철수 & 응웬 티 란" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold">김철수 & 응웬 티 란</h3>
                  <p className="text-sm text-gray-600">결혼 1년차</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "처음에는 문화 차이가 걱정됐지만, 서로를 이해하려는 노력으로 행복한 가정을 이루고 있습니다. 이 서비스를 통해 제 인생의 동반자를 만나게 되어 정말 감사합니다."
              </p>
              <div className="flex">
                <span className="text-yellow-400">★★★★★</span>
              </div>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
              <div className="flex items-center mb-6">
                <div className="mr-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img 
                      src="https://images.unsplash.com/photo-1577644887050-5a5c311015ac?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" 
                      alt="박진우 & 팜 민 트" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold">박진우 & 팜 민 트</h3>
                  <p className="text-sm text-gray-600">결혼 2년차</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "베트남 신부와의 결혼을 고민하시는 분들께 자신있게 추천합니다. 지금은 아이도 생겨 더없이 행복한 가정을 이루고 있습니다. 모든 과정에서 전문적인 도움을 받을 수 있었습니다."
              </p>
              <div className="flex">
                <span className="text-yellow-400">★★★★★</span>
              </div>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
              <div className="flex items-center mb-6">
                <div className="mr-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img 
                      src="https://images.unsplash.com/photo-1542343633-ce3256f2183e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" 
                      alt="이상호 & 부이 티 홍" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold">이상호 & 부이 티 홍</h3>
                  <p className="text-sm text-gray-600">결혼 3년차</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "국제결혼에 대한 편견이 있었지만, 진심으로 서로를 아끼는 마음으로 행복하게 살고 있습니다. 통역부터 문화 이해까지 세심한 케어가 큰 도움이 되었습니다."
              </p>
              <div className="flex">
                <span className="text-yellow-400">★★★★★</span>
              </div>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <Link to="#" className="inline-block text-primary-600 hover:text-primary-700 font-medium">
              더 많은 성공 사례 보기 →
            </Link>
          </div>
        </div>
      </section>
      
      {/* CTA 섹션 */}
      <section className="py-16 md:py-24 relative">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1583417319070-4a69db38a482?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" 
            alt="베트남 결혼식" 
            className="w-full h-full object-cover brightness-50"
          />
        </div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              새로운 인연을 찾을 준비가 되셨나요?
            </h2>
            <p className="text-xl text-white opacity-90 mb-8">
              지금 무료 상담을 신청하고 맞춤형 국제 결혼 서비스를 경험해보세요.
            </p>
            <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <Link 
                to="#" 
                className="bg-white text-primary-700 hover:bg-gray-100 px-8 py-3 rounded-md text-lg font-medium inline-block"
              >
                무료 상담 신청하기
              </Link>
              <Link 
                to="/match" 
                className="bg-transparent border border-white text-white hover:bg-white/10 px-8 py-3 rounded-md text-lg font-medium inline-block"
              >
                매칭 서비스 보기
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default Home; 